import { render } from "./userList.vue?vue&type=template&id=0605c11c&scoped=true"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"

import "./userList.vue?vue&type=style&index=0&id=0605c11c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0605c11c"]])

export default __exports__